export const contractStaking = {
  pool_1: {
    address: "0x9Cc34a3fAAf0f6A4a7733a33ce603a69e4b273AB", // 30DAY
    token: {
      from: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7",
      to: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7"
    }
  },
  pool_2: {
    address: "0x6b100897a60B30352FeCBd50b86a4a49E823C5c4", // 60DAY
    token: {
      from: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7",
      to: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7"
    }
  },
  pool_3: {
    address: "0x0BdfC7d047c1797C19c46d27D876C71C5E619BEE", //90DAY
    token: {
      from: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7",
      to: "0x00Da149c4E01E4a391Ab86DEdDaAE66E906B6fB7"
    }
  }
};
